var exports = {
  "nA": "tableRoot__GKR8wt",
  "YH": "gridLines__CO1x1q",
  "E0": "tableBodyContainer__s12mmN",
  "PH": "fixedOmnibar__Gqzp2E",
};

module.exports = exports;
